
import { Component, Vue, Prop } from "vue-property-decorator";

import ProductionDocs from "../../../views/orders/parts/ProductionDocs.vue";
import PazTooltipButton from "@pazion/pazion-core/src/components/controls/PazTooltipButton.vue";
import PazConfirmation from "@pazion/pazion-core/src/components/utils/PazConfirmation.vue";

import { IOrderLine } from "../../../models/order";

import {
  getProductionRecords,
  updateProductionLine,
  deleteProductionLine,
} from "../../../services/order-service";

@Component({
  components: { ProductionDocs, PazTooltipButton, PazConfirmation },
})
export default class PazOrderProductionRecords extends Vue {
  $refs!: {
    confirm: PazConfirmation;
  };

  @Prop({ default: null })
  readonly order!: IOrderLine;

  @Prop() public lineWorkTypes: any;

  public currentProdType: string = "";

  private productionRecords = [];

  public headers = [
    { text: "Status", align: "center", value: "status" },
    { text: "Description", align: "center", value: "description" },
    { text: "Quantity", align: "center", value: "quantity" },
    { text: "Production type", align: "center", value: "extra" },
    { text: "Line notes", align: "center", value: "notes" },
    { text: "Actions", align: "center", value: "actions" },
  ];

  get getProductionRecord() {
    return this.productionRecords;
  }

  async fetchProductionRecords() {
    this.productionRecords = await getProductionRecords(this.order.id, {
      expand: "productionLine",
    });
  }

  public selectedProductionLineId: string = "";

  async deleteLine(item: any) {
    const confirm = await this.$refs.confirm.openConfirmDialog(
      "Delete",
      `Are you sure you want to delete ${item.quantity} x ${item.description}`
    );
    if (confirm) {
      await deleteProductionLine({ id: item.id });
      setTimeout(() => {
        this.fetchProductionRecords();
      }, 100);
    }
  }

  isAbleToEdit(id: string) {
    return this.selectedProductionLineId === id;
  }

  async selectProductionLine(item: any) {
    if (this.selectedProductionLineId === item.id) {
      await updateProductionLine({
        id: item.id,
        data: { notes: item.notes, workspace: item.workspace },
      });
      this.selectedProductionLineId = "";
      return;
    }
    this.selectedProductionLineId = item.id;
  }

  downloadFile(fileBlob: string, fileName: string){
    var a = document.createElement("a"); //Create <a>
    a.href = fileBlob; //Image Base64 Goes here
    a.download = fileName; //File name Here
    a.click();
  }

  editBtnIcon(id: string) {
    return this.isAbleToEdit(id) ? "mdi-check" : "mdi-pencil";
  }

  editBtnColor(id: string) {
    return this.isAbleToEdit(id) ? "success" : "blue";
  }

  editBtnTooltip(id: string) {
    return this.isAbleToEdit(id) ? "Submit" : "Edit";
  }

  async mounted() {
    await this.fetchProductionRecords();
  }
}
